import {
  FETCH_CONFIG,
  CREATE_CONFIG,
  UPDATE_CONFIG,
  DELETE_CONFIG,
  DELETE_ALL_CONFIG,
  SET_DEFAULT_CONFIG,
  UPDATE_HEADER,
  GET_CONFIG_BYNAME,
  UPDATE_DASHBOARD_BANNER,
  GET_DROPBOX_AUTHORIZED_URL
} from "../actions";
const initialState = {
  deleted: null,
  deleteAll: null,
  setDefault: null,
  newConfig: null,
  updatedConfig: null,
  configs: [],
  headerImage: null,
  loading: false,
  pdfVersionStatus: null,
  newConfigError: null,
  fetchConfigError: null,
  updateConfigError: null,
  deleteConfigError: null,
  deleteAllConfigError: null,
  setDefaultConfigError: null,
  headerImageError: null,
  configStatusError: null,
};

function configReducer(state = initialState, action) {
  let deleted,
    newConfig,
    updatedConfig,
    configs,
    deleteAll,
    setDefault,
    headerImage,
    newConfigError,
    fetchConfigError,
    updateConfigError,
    deleteConfigError,
    deleteAllConfigError,
    setDefaultConfigError,
    headerImageError,
    pdfVersionStatus,
    configStatusError,
    dashboardBanner,
    ceratedDropBoxUrl; 
  

  switch (action.type) {
    case `${FETCH_CONFIG}_PENDING`:
    case `${CREATE_CONFIG}_PENDING`:
    case `${UPDATE_CONFIG}_PENDING`:
    case `${DELETE_CONFIG}_PENDING`:
    case `${DELETE_ALL_CONFIG}_PENDING`:
    case `${SET_DEFAULT_CONFIG}_PENDING`:
    case `${UPDATE_HEADER}_PENDING`:
      return { ...state, loading: true };
    case `${GET_CONFIG_BYNAME}_PENDING`:
      return { ...state, loading: true };
    case `${FETCH_CONFIG}_FULFILLED`:
      configs = action.payload.data;
      return { ...state, loading: false, configs };
    case `${CREATE_CONFIG}_FULFILLED`:
      newConfig = action.payload.data;
      return { ...state, loading: false, newConfig };
    case `${UPDATE_CONFIG}_FULFILLED`:
      updatedConfig = action.payload.data;
      return { ...state, loading: false, updatedConfig };
    case `${DELETE_CONFIG}_FULFILLED`:
      deleted = action.payload.data;
      return { ...state, loading: true, deleted };
    case `${DELETE_ALL_CONFIG}_FULFILLED`:
      deleteAll = action.payload.data;
      return { ...state, loading: false, deleteAll };
    case `${SET_DEFAULT_CONFIG}_FULFILLED`:
      setDefault = action.payload.data;
      return { ...state, loading: false, setDefault };
    case `${UPDATE_HEADER}_FULFILLED`:
      headerImage = action.payload.data;
      return { ...state, loading: false, headerImage };

    case `${UPDATE_DASHBOARD_BANNER}_FULFILLED`:
        dashboardBanner = action.payload.data;
        return { ...state, loading: false, dashboardBanner };  

    case `${GET_DROPBOX_AUTHORIZED_URL}_FULFILLED`:
      ceratedDropBoxUrl = action.payload.data;
      return { ...state, loading: false, ceratedDropBoxUrl }; 

    case `${GET_CONFIG_BYNAME}_FULFILLED`:
        let configStatus = action.payload.data;  
        return { ...state, loading: false, configStatus };
    case `${FETCH_CONFIG}_REJECTED`:
      fetchConfigError = `${action.payload.message}`;
      return {
        ...state,
        loading: false,
        fetchConfigError: fetchConfigError
      };
    case `${CREATE_CONFIG}_REJECTED`:
      newConfigError = `${action.payload.message}`;

      return {
        ...state,
        loading: false,
        newConfigError: fetchConfigError
      };
    case `${UPDATE_CONFIG}_REJECTED`:
      updateConfigError = `${action.payload.message}`;
      return {
        ...state,
        loading: false,
        updateConfigError: updateConfigError
      };
    case `${DELETE_CONFIG}_REJECTED`:
      deleteConfigError = `${action.payload.message}`;
      return {
        ...state,
        loading: false,
        deleteConfigError: deleteConfigError
      };
    case `${DELETE_ALL_CONFIG}_REJECTED`:
      deleteAllConfigError = `${action.payload.message}`;
      return {
        ...state,
        loading: false,
        deleteAllConfigError: deleteAllConfigError
      };
    case `${SET_DEFAULT_CONFIG}_REJECTED`:
      setDefaultConfigError = `${action.payload.message}`;
      return {
        ...state,
        loading: false,
        setDefaultConfigError: setDefaultConfigError
      };
    case `${UPDATE_HEADER}_REJECTED`:
      headerImageError = `${action.payload.message}`;

      return {
        ...state,
        loading: false,
        headerImageError: headerImageError
      };
    case `${GET_CONFIG_BYNAME}_REJECTED`:
      configStatusError = `${action.payload.message}`;
      return {
      ...state,
      loading: false,
      configStatusError: configStatusError
      };

    default:
      return state;
  }
}
export default configReducer;
